export enum Emit {
  ChangeFilter = 'change-filter',
  ClearAllFilters = 'clear-all-filters',
}
